/**
 * PURPOSE: represents the different role options as an enum
 */
export enum RoleEnum {
  ROLE_COMPANY_BRIDGE = "ROLE_COMPANY_BRIDGE",
  ROLE_COMPANY_AGENTIUM = "ROLE_COMPANY_AGENTIUM",
  ROLE_CONSOLE_ADMIN = "ROLE_CONSOLE_ADMIN",
  ROLE_CONSOLE_AGENCY_ADMIN = "ROLE_CONSOLE_AGENCY_ADMIN",
  ROLE_CONSOLE_CARRIER = "ROLE_CONSOLE_CARRIER",
  ROLE_CONSOLE_PRODUCER = "ROLE_CONSOLE_PRODUCER"
}
